export default __webpack_public_path__ + "static/google-scholar-logo-light-41c04844af3fb277fd714ed988827abc.svg";